const moneyFormat = (money:any) => {
    if(money){
        return money?.toLocaleString(undefined, {minimumFractionDigits: 2}) + "₺";
    } else {
        let num = 0;
        return num.toLocaleString(undefined, {minimumFractionDigits: 2}) + "₺";
    }
}

export {moneyFormat}